import { PgliteDatabase } from "drizzle-orm/pglite";
import { contacts, InsertContact, SelectContact } from "../schema";
import { and, eq, ne } from "drizzle-orm";

class ContactsRepository {
    public getById = async (db: PgliteDatabase, id: number) => {
        const [res] = await db.select().from(contacts).where(eq(contacts.id, id));
        return res;
    }
    public addContact = async (db: PgliteDatabase, contact: InsertContact) => {
        const [res] = await db.insert(contacts).values(contact).returning();
        return res;
    }
    public addMany = async (db: PgliteDatabase, items: InsertContact[]) => {
        return await db.insert(contacts).values(items).returning();
    }
    public getCustomerContacts = async (db: PgliteDatabase, customerId: number): Promise<SelectContact[]> => {
        return await db.select().from(contacts)
            .where(and(eq(contacts.customerId, customerId), ne(contacts.status, "archived")));
    }
    public updateContact = async (db: PgliteDatabase, contact: InsertContact) => {
        const [res] = await db.update(contacts).set(contact)
            .where(eq(contacts.id, contact.id as number)).returning();
        return res;
    }
    public deleteContact = async (db: PgliteDatabase, contactId: number) => {
        await db.update(contacts).set({ status: "archived" }).where(eq(contacts.id, contactId));
    }
    public restoreContact = async (db: PgliteDatabase, id: number) => {
        const [res] = await db.update(contacts).set({ status: "active" }).where(eq(contacts.id, id)).returning();
        return res;
    }
}

export const contactsRepository = new ContactsRepository();